import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { reportError as _reportError } from '../Redux/ApplicationActions';
import type { ReducerError } from '../Utils/reducerError';
// The auth state is owned by flowhawk-core, so its reducerErrors use flowhawk-core's own
// (more loosely typed) ReducerError rather than our local one.
import type { ReducerError as CoreReducerError } from 'flowhawk-core';
import type { RootState } from '../Redux';

type Props = {
  applicationErrors: ReducerError[];
  authErrors: CoreReducerError[];
  chatEditErrors: ReducerError[];
  chatListErrors: ReducerError[];
  chatMessageErrors: ReducerError[];
  chatroomErrors: ReducerError[];
  loadingErrors: ReducerError[];

  reportError: (error: ReducerError) => void;
};

class ErrorLogger extends PureComponent<Props> {
  sendFirstError = (errors: ReducerError[] | CoreReducerError[]) => {
    const { reportError } = this.props;

    if (errors && errors.length > 0) {
      const thisError = errors[0];
      reportError(thisError as ReducerError);
    }
  };

  render() {
    const {
      applicationErrors,
      authErrors,
      chatEditErrors,
      chatListErrors,
      chatMessageErrors,
      chatroomErrors,
      loadingErrors,
    } = this.props;

    // Just send the first error from each stack to the Saga and then to be cleared.
    // Considered doing all but concerned that the clear will update the state causing this to rerun
    // which will then try to clear some of errors being cleared in another render
    this.sendFirstError(applicationErrors);
    this.sendFirstError(authErrors);
    this.sendFirstError(chatEditErrors);
    this.sendFirstError(chatListErrors);
    this.sendFirstError(chatMessageErrors);
    this.sendFirstError(chatroomErrors);
    this.sendFirstError(loadingErrors);

    return '';
  }
}

const mapStateToProps = (state: RootState) => ({
  applicationErrors: state.application.reducerErrors,
  authErrors: state.auth.reducerErrors,
  chatEditErrors: state.chatEdit.reducerErrors,
  chatListErrors: state.chatList.reducerErrors,
  chatMessageErrors: state.chatMessage.reducerErrors,
  chatroomErrors: state.chatroom.reducerErrors,
  loadingErrors: state.loading.reducerErrors,
});
export default connect(mapStateToProps, {
  reportError: _reportError,
})(ErrorLogger);
